import { useStaticQuery, graphql } from "gatsby";

export const useNewsAndInsights = () => {
  const { glstrapi } = useStaticQuery(graphql`
    query NewsAndInsightsSharedQuery {
      glstrapi {
        newsAndInsights(sort: "createdAt:desc", limit: 50) {
          id
          Title
          URL
          Published_Date
          Service
          news_and_insights_category { Name }
          Embed_Video_URL
          Image { url alternativeText }
          imagetransforms
          ggfx_results { id content_type transforms src_import_url src_cftle field }
          insight_departments { Name }
        }
      }
    }
  `)
  return glstrapi?.newsAndInsights || []
}
